export function toFixedReliable(num, precision = 0) {
    return (+(Math.round(+(num + 'e' + precision)) + 'e' + -precision)).toFixed(precision)
}
